import { useEffect, useState } from 'react'
import detectBrowserLanguage from 'detect-browser-language'

const useLanguage = () => {
  const [language, setLanguage] = useState(1)

  useEffect(() => {
    if (!localStorage.getItem('language')) {
      if (detectBrowserLanguage() === 'pt-BR' || detectBrowserLanguage() === 'pt-PT' || detectBrowserLanguage() === 'pt' || detectBrowserLanguage().slice(0, 2) === 'pt') {
        setLanguage(0)
        localStorage.setItem('language', '0')
      }
      if (detectBrowserLanguage().slice(0, 2) === 'es') {
        setLanguage(2)
        localStorage.setItem('language', '2')
      }
    } else {
      setLanguage(localStorage.getItem('language') - '0')
    }
  }, [])

  return language
}

export default useLanguage



// WEBPACK FOOTER //
// ./src/hooks/useLanguage.js